import { Text, Box, FlexProps, Flex, IconButton } from 'theme-ui'
import { InfoIcon } from 'components/Icon'
import { Tooltip } from 'components'
import { noop } from 'utils'
import { useState } from 'react'

import './SearchNetSuiteResults.css'

export type SearchNetSuiteResultsProps = {
  results?: any[]
  noResults?: boolean
  error?: string
  onSearchItemClick?: (data: any) => void
}

type SearchNetSuiteItemProps = FlexProps & {
  email: string
  firstname: string
  lastname: string
  centerName: string
  centerLocation: string
  id: string
  tmapp_user_id: string
  onSearchItemClick?: (data: any) => void
}

function SearchNetSuiteItem({
  email,
  firstname,
  lastname,
  centerName,
  centerLocation,
  id,
  tmapp_user_id,
  onSearchItemClick = noop,
  ...rest
}: SearchNetSuiteItemProps) {
  const noColor = ''
  const hoverColor = 'rgba(241, 237, 219, 0.5)'
  const clickedColor = '#ffc436'
  const alreadyLinkedColor = '#eee'

  const [bgColor, setBgColor] = useState<string>(noColor)

  const isLeadLinked = tmapp_user_id.length > 0
  centerLocation =
    centerLocation === 'undefined' || !centerLocation
      ? 'No Location Data'
      : centerLocation

  const handleClick = () => {
    if (!isLeadLinked) {
      setBgColor(clickedColor)
      setTimeout(
        () =>
          onSearchItemClick({
            id,
            forename: firstname,
            surname: lastname,
            email,
            centerLocation,
          }),
        0
      )
    }
  }
  const handleMouseIn = () => {
    setBgColor(hoverColor)
  }
  const handleMouseOut = () => {
    setBgColor(noColor)
  }

  return (
    <Flex
      onClick={handleClick}
      onMouseEnter={handleMouseIn}
      onMouseLeave={handleMouseOut}
      sx={{
        position: 'relative',
        p: '4px',
        px: '16px',
        minHeight: [88, 50],
        userSelect: 'none',
        cursor: 'default',
        bg: isLeadLinked ? alreadyLinkedColor : bgColor,
        textAlign: 'left',
      }}
      {...rest}>
      <Flex
        sx={{
          flexDirection: ['column', 'row'],
          justifyContent: ['center', 'left'],
        }}>
        {isLeadLinked && (
          <Box sx={{ position: 'absolute', left: -1, top: [2, 2], m: 'auto' }}>
            <Tooltip variant="linked" tooltipSx={{}}>
              <IconButton variant={`icon.inactive`} sx={{ outline: 'none' }}>
                <InfoIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
        <Box sx={{ flex: '0 0 auto', my: [0, 'auto'], px: 2, minWidth: 180 }}>
          <Text variant="text.result" sx={{ pl: '1px', fontWeight: 'heading' }}>
            {firstname} {lastname}
          </Text>
        </Box>

        <Box
          sx={{
            display: ['block', 'none'],
            flex: '0 0 18px',
            mt: [0, 'auto'],
            px: 2,
            minWidth: 200,
          }}>
          <Text variant="text.informational">
            {email}, {centerLocation}
          </Text>
        </Box>

        <Box
          sx={{
            display: ['none', 'block'],
            flex: '0 0 auto',
            margin: 'auto',
            px: 2,
            minWidth: 200,
          }}>
          <Text variant="text.informational">{email}</Text>
        </Box>
        <Box
          sx={{ display: ['none', 'block'], flex: '1 0 auto', margin: 'auto' }}>
          <Text variant="text.informational" sx={{ fontSize: 1 }}>
            {centerLocation}
          </Text>
        </Box>
      </Flex>
    </Flex>
  )
}

export function SearchNetSuiteResults({
  results = [],
  noResults = false,
  onSearchItemClick = noop,
}: SearchNetSuiteResultsProps) {
  const shouldScroll = results.length > 4
  return (
    <Box
      aria-hidden={noResults ? 'true' : 'false'}
      style={{
        visibility: noResults && shouldScroll ? 'hidden' : 'visible',
        pointerEvents: noResults && shouldScroll ? 'none' : 'auto',
      }}
      className="SearchNetSuiteResults">
      {!noResults &&
        results.map((result: any) => (
          <SearchNetSuiteItem
            key={result.internal_id}
            email={result.email}
            firstname={result.first_name}
            lastname={result.last_name}
            centerLocation={result.center_location}
            centerName={result.center_name}
            id={result.internal_id}
            tmapp_user_id={result.tmapp_user_id}
            onSearchItemClick={onSearchItemClick}
          />
        ))}
      {noResults && (
        <Box sx={{ padding: 3 }}>
          <Box>
            <Text sx={{ fontSize: 2 }}>
              We couldn't find any matching record for this student. Enter exact
              name or email for the student into the input form above.
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  )
}
